import { render } from "./_payment-pix.vue?vue&type=template&id=07517d64&scoped=true&bindings={\"enablePaymentButton\":\"props\",\"getData\":\"options\",\"openPixQrCode\":\"options\",\"copyToClipboard\":\"options\"}"
import script from "./_payment-pix.vue?vue&type=script&lang=js"
export * from "./_payment-pix.vue?vue&type=script&lang=js"

import "@/assets/css/checkout-paymentcreditcard.module.css?vue&type=style&index=0&id=07517d64&scoped=true&lang=css"
import "@/assets/css/checkout-paymentpix.module.css?vue&type=style&index=1&id=07517d64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07517d64"

export default script